module.exports = __webpack_public_path__ + "static/media/pause.9c67e9ce.svg";